import React, {Component} from 'react';

import MicVisualizer from "../other/MicVisualizer";
import withRecognizerRDT2 from "./withRecognizerRDT2";
import {isIOS, isMobile} from "../../asset/js/myFunctions";


class Footer_RDT_B extends Component {

    constructor(props) {
        super(props);
        this.state={
            index:999,
        };
        this.endRecognitionTimer = null;

        this._testStart = this._testStart.bind(this);
    }

    //현재 페이지를 state.index에 저장함.
    static getDerivedStateFromProps(nextProps, prevState) {

        if(nextProps.wordInfo.getResult === false && nextProps.recognizerReady === true && nextProps.wordInfo.num !== prevState.index){
            //만약 아직 결과를 못받았고, 리코그나이저가 준비되어 있으며 wordInfo의 num 가 새로운 것일 경우 테스트를 실행하고 index를 num에 맞춤.
            ////console.log("received paragraphInfo is: "+ nextProps.wordInfo.num + " " + nextProps.wordInfo.getResult);
            //this._test3Words();
            return{
                index: nextProps.wordInfo.num,
            }
        }
        return null;
    }

    componentDidMount(){
        if(this._canStartRecognition(this.props, this.state.index)){
            this._startRecognition();
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.listening && !this.props.listening){
            this._clearEndRecognitionTimer();
        }

        if(prevProps.listening !== this.props.listening){
            this.props.isListening(this.props.listening);
        }

        if(prevState.index !== this.state.index && this._canStartRecognition(this.props, this.state.index)){
            this._startRecognition();
        }
    }

    componentWillUnmount() {
        this._clearEndRecognitionTimer();
    }

    render() {
        // //console.log(this.props.currentPage + " and " + this.props.maxPage);
        ////console.log("In ControlPanel, currentMenuNumber is:"+ this.props.currentMenu);

        return (

            <section className="view-footer">

                {
                    this.props.listening ?
                        <MicVisualizer/>
                        :
                        this.props.waiting ?
                            <button type="button" className="f-btn">Empty</button>
                            :
                            this.props.recognizerReady ?
                                <button
                                    type="button"
                                    className="f-btn f-center btn-test"
                                    onClick={() => {
                                        this._testStart()
                                    }}>
                                </button>
                                :
                                <button type="button" className="f-btn">Empty</button>
                }
            </section>

        );
    }


    _testStart = () => {
        this.props.closeTip();

        if(isIOS){
            this.props.fakeRecognitionStart();
            this.props.audioPlayMute("eng",this.props.wordInfo.num,
                () => setTimeout(() => {this.props.fakeRecognitionEnd()},1000)
            );
        } else {
            this.props.startRecognition();
            this._schedulePcEndRecognition(this.props.wordInfo.num);
        }

        this.props.handleError(null);
    };

    _canStartRecognition = (props, index) => {
        return props.wordInfo.getResult === false && props.recognizerReady === true && props.wordInfo.num === index;
    }

    _startRecognition = () => {
        if(isIOS){
            this.props.fakeRecognitionStart();
            this.props.audioPlayMute("eng",this.props.wordInfo.num,
                () => setTimeout(() => {this.props.fakeRecognitionEnd()},1000)
            );
        } else {
            this.props.startRecognition();
            this._schedulePcEndRecognition(this.props.wordInfo.num);
        }
    }

    _schedulePcEndRecognition = (index) => {
        if(isMobile){
            return;
        }

        const content = this.props.contents && this.props.contents[index];

        if(!content) {
            return;
        }

        this.props.setHowlerMute(
            `${content.step_code}/${content.lesson_no}/${content.eng_url}`,
            () => {
                if(this.props.listening) {
                    this._scheduleEndRecognition(1000);
                }
            }
        )
    }

    _scheduleEndRecognition = (duration) => {
        this._clearEndRecognitionTimer();
        this.endRecognitionTimer = setTimeout(() => {
            this.props.endRecognition();
            this.endRecognitionTimer = null;
        }, duration);
    }

    _clearEndRecognitionTimer = () => {
        if(this.endRecognitionTimer !== null) {
            clearTimeout(this.endRecognitionTimer);
            this.endRecognitionTimer = null;
        }
    }

}

export default withRecognizerRDT2()(Footer_RDT_B);
    
